module.exports = __webpack_public_path__ + "static/media/sacha.f85fefaa.jpg";